<template>
  <div class="personalize-stepper-wrapper__form ion-padding">
    <Form
      form-name="login"
      id="loginForm"
      :validation-schema="schemaSelected"
      @submit="handlePersonalizeSubmit"
    >
      <ion-row>
        <ion-col size="12">
          <swiper ref="signUpSwiper" :modules="[Navigation]" @swiper="onSwiper">
            <swiper-slide class="swiper-no-swiping">
              <PersonalizeStepperCity />
            </swiper-slide>
            <swiper-slide class="swiper-no-swiping">
              <PersonalizeStepperDates />
            </swiper-slide>
            <swiper-slide class="swiper-no-swiping">
              <PersonalizeStepperPurpose />
            </swiper-slide>
            <swiper-slide class="swiper-no-swiping">
              <PersonalizeStepperInfo />
            </swiper-slide>
          </swiper>
        </ion-col>
      </ion-row>
      <ion-row v-if="swiperPersonalize?.activeIndex == 0">
        <ion-col size="6">
          <ion-button
            fill="clear"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            @click="goBack"
          >
            <ion-icon slot="start" :icon="chevronBackOutline" aria-hidden="true"></ion-icon>
            {{ t('global.back') }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            fill="solid"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            type="submit"
          >
            <ion-icon slot="end" :icon="chevronForwardOutline" aria-hidden="true"></ion-icon>
            {{ t('global.next') }}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row v-else>
        <ion-col size="6">
          <ion-button
            fill="clear"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            @click="goBack"
          >
            <ion-icon slot="start" :icon="chevronBackOutline" aria-hidden="true"></ion-icon>
            {{ t('global.back') }}
          </ion-button>
        </ion-col>
        <ion-col size="6">
          <ion-button
            fill="solid"
            class="text-sm"
            color="primary"
            expand="block"
            size="default"
            type="submit"
          >
            {{ t('global.next') }}
          </ion-button>
        </ion-col>

        <ion-progress-bar v-if="isLoading" type="indeterminate"></ion-progress-bar>
      </ion-row>
    </Form>
  </div>
</template>
<script setup lang="ts">
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Navigation } from 'swiper/modules';
  import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons';
  import { IonButton, IonCol, IonIcon, IonRow, IonProgressBar } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import router from '@/router';
  import { Form } from 'vee-validate';
  import PersonalizeStepperCity from '@/components/personalize/PersonalizeStepperCity.vue';
  import PersonalizeStepperInfo from '@/components/personalize/PersonalizeStepperInfo.vue';
  import PersonalizeStepperDates from '@/components/personalize/PersonalizeStepperDates.vue';
  import PersonalizeStepperPurpose from '@/components/personalize/PersonalizeStepperPurpose.vue';
  import { usePersonalize } from '@/composables/usePersonalize';
  import { computed, ref } from 'vue';
  import { useAuth } from '@/composables/useAuth';
  import { useProfileStore } from '@/stores/profile-store';
  import { storeToRefs } from 'pinia';
  import { useProfile } from '@/composables/useProfile';
  import { useSchemas } from '@/composables/useSchemas';

  const { schemaPersonalizeCity, schemaPersonalizeDates, schemaPersonalizeInfo } = useSchemas();
  const { t } = useI18n();
  const { swiperPersonalize, personalizeForm } = usePersonalize();
  const { profileForm } = storeToRefs(useProfileStore());
  const { handlePutProfile } = useProfile();
  const { goTo } = useAuth();
  const isLoading = ref(false);

  const schemaSelected = computed(() => {
    switch (swiperPersonalize.value?.activeIndex) {
      case 0:
        return schemaPersonalizeCity;
      case 1:
        return schemaPersonalizeDates;
      case 2:
        return undefined;
      case 3:
        return schemaPersonalizeInfo;
      default:
        return schemaPersonalizeCity;
    }
  });

  function onSwiper(swiper: any) {
    swiperPersonalize.value = swiper;
  }

  const handlePersonalizeSubmit = () => {
    switch (swiperPersonalize.value?.activeIndex) {
      case 0:
        swiperPersonalize.value?.slideNext();
        break;
      case 1:
        swiperPersonalize.value?.slideNext();
        break;
      case 2:
        swiperPersonalize.value?.slideNext();
        break;
      case 3:
        profileForm.value.birthday = personalizeForm.value.birthdate;
        profileForm.value.userType =
          personalizeForm.value.purpose !== 'leisure' ? personalizeForm.value.purpose : 'other';
        profileForm.value.name = personalizeForm.value.name as string;
        profileForm.value.lastName = personalizeForm.value.lastname as string;
        profileForm.value.NationalityId = undefined;
        profileForm.value.genre = undefined;
        profileForm.value.phoneNumber = undefined;

        isLoading.value = true;
        handlePutProfile().then(() => {
          isLoading.value = false;
          goTo('personalizeQuestions');
        });

        break;
      default:
        swiperPersonalize.value?.slideNext();
        break;
    }
  };

  const goBack = () => {
    switch (swiperPersonalize.value?.activeIndex) {
      case 0:
        router.back();
        break;
      case 1:
        swiperPersonalize.value?.slidePrev();
        break;
      case 2:
        swiperPersonalize.value?.slidePrev();
        break;
      case 3:
        swiperPersonalize.value?.slidePrev();
        break;
      default:
        swiperPersonalize.value?.slidePrev();
        break;
    }
  };
</script>
<style scoped lang="scss">
  .personalize-stepper-wrapper {
    &__form {
      width: 100%;
      border-radius: 16px;
      background: #ffffff;
      min-height: 200px;
      margin-bottom: 50px;
    }
  }
  .swiper {
    overflow: visible !important;
  }
  .swiper-slide-prev,
  .swiper-slide-next {
    visibility: hidden;
  }

  .dp__outer_menu_wrap,
  .dp--menu-wrapper {
    overflow: hidden;
    background: #1c4197;
  }
</style>
